import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DailyRateWarningModal = ({ open, onCancel, onProceed, rateLabel = "Rental Rate", dailyLabel = "Daily Rent" }) => {
  return (
    <Dialog aria-labelledby="daily-rate-warning-title" className="add-lease-dialog" open={open} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }} className="dialog-header" id="daily-rate-warning-title">
        <WarningAmberIcon sx={{ color: "#a78701" }} /> Enable {dailyLabel} on an active lease?
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          This {rateLabel} is part of an <b>active, in-progress lease</b>. Enabling {dailyLabel} will change how invoices are calculated <b>from this point forward</b>. Previously generated, sent or paid invoices are <b>not</b> recalculated.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: 1, justifyContent: "flex-end", marginRight: "15px" }}>
        <Button className="cancel-btn" size="small" variant="outlined" onClick={onCancel}>Cancel</Button>
        <Button size="small" variant="contained" onClick={onProceed}>Proceed anyway</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DailyRateWarningModal;
